
import { IDiary, Diary, DiaryInsert, IDiaryHandler, UserState, UserHeader } from "@harlowe/core";
import {TealHealthEncounter, TealHealthEncounterDetails, TealHealthEncounterHeader } from "../../../models/encounter";
import { Store } from "@ngxs/store";
import { EncounterService } from "../../../services/encounter.service";

export class EncounterDiaryHandler implements IDiaryHandler
{
    

    constructor
    (
        private encounter: TealHealthEncounter| TealHealthEncounterDetails | TealHealthEncounterHeader,
        private _encounters:EncounterService,
        private _store:Store
    )
    {

    }

    async addDiary(diary: IDiary) : Promise<Diary | undefined>
    {
        var user = this._store.selectSnapshot(UserState.currentUser);
        if(user && this.encounter)
        {
            var di = new DiaryInsert(user.id,diary.subject ?? "",diary.body ?? "");
            di.dueDate = diary.dueDate;
            di.assignedToId = diary.assignedTo?.id;
            return await this._encounters.addNewDiary(this.encounter.id,di);
        }
        return Promise.resolve(undefined);

    }

    closeDiary(diary: Diary) : void
    {
        if(this.encounter)
            this._encounters.closeDiary(this.encounter.id,diary.id);
    }

    assignDiary(diary: Diary, user: UserHeader, dueDate: Date) : void
    {
        if(this.encounter)
            this._encounters.assignDiary(this.encounter.id,diary.id,user.id,dueDate);
    }
}